"use strict";
import React, { Component } from "react";
import Table from "./Table";
import Header from "./Header";

class Tarjeta extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        /*Se extraen las funciones en un paquete*/
        const bundleFunciones = {
            actualizarNovedadEstado: this.props.actualizarNovedadEstado,
            bloquearTarjeta: this.props.bloquearTarjeta,
            cancelar: this.props.cancelar,
            changeCheck: this.props.changeCheck,
            changeInput: this.props.changeInput,
            estadoEdicion: this.props.estadoEdicion,
            guardarNovedad: this.props.guardarNovedad,
            guardarNovedadBloqueo: this.props.guardarNovedadBloqueo,
            mostrarModal: this.props.mostrarModal,
            selectCombo: this.props.selectCombo,
            getDiasVigencia: this.props.getDiasVigencia
        }

        return <div>
            <Header data={this.props.data} />
            <Table data={this.props.data}
                funciones={bundleFunciones} />
        </div>
    }

}
export default Tarjeta;